var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card-buttons-button"},[_c('div',{staticClass:"card-buttons-button-text"},[_vm._t("default")],2),(_vm.count)?_c('span',{staticClass:"card-buttons-button-count"},[_vm._v(_vm._s(_vm.count))]):_vm._e(),_c('i',{staticClass:"fa fa-caret-right"})])
}
var staticRenderFns = []

export { render, staticRenderFns }